import React from "react";
import useDebounce from "../../Hooks/useDebounce";

const InputSearchUser = (state) => {
  const { aux: users, setUsers } = state;

  const searchUsers = useDebounce(
    (_user) => {
      

      if (_user === "") {
        setUsers(users)
        return;
      }

      const filter = users.filter((elm) =>
        elm.name?.toLowerCase().includes(_user?.toLowerCase())
      );

      setUsers(filter)

    },
    [users, setUsers]
  );

  return (
    <div className="form-group mb-3">
      <input
        onChange={({ target }) => searchUsers(target.value)}
        className="form-control"
        placeholder="&#128270; Search user"
      />
    </div>
  );
};

export default InputSearchUser;
